// extracted by mini-css-extract-plugin
export default {"tooltip2":"tooltip_tooltip2__OeQz8","tooltipOnHover":"tooltip_tooltipOnHover__HPlL4","innerTooltip":"tooltip_innerTooltip__LXD0A"};